export default __webpack_public_path__ + "static/media/banner_cubi.797ceef6.svg";